// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2lqVd","title":"Info_title__usq42","links":"Info_links__BWMXG","link":"Info_link__SwAeX","logo":"Info_logo__1t909"};